import React, { useEffect, useState } from 'react'
import Header from '../Components/Header'
import { Alert, Avatar, Box, Container, Icon, IconButton, Typography } from '@mui/material'
import demo from "../Files/demo.svg"
import support from "../Files/support.svg"
import renseignement from "../Files/renseignement.svg"
import image from "../Files/Titles/articles.png"
import Footer from '../Components/Footer'
import illustation from "../Files/Career Illustration.svg"
import photo from "../PXL_20231009_125631885.jpg"
import Project from '../Components/Project'
import { LinkedIn, GitHub, Instagram, Facebook, Mail, Description, FormatQuote, PostAdd, Article, Share, ThumbUp, ThumbDown, CopyAll, Send, Mic, SendRounded, MicOff, Cancel, VoiceOverOff, RecordVoiceOver, MoveDown, ArrowDropDown } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import SocialLink from '../Components/SocialLink'
import Formations from "../Data/Formations.json";
import { Carousel, Form } from 'antd'
import TopHeader from '../Components/TopHeader'
import TitrePage from './TitrePage'
import { motion, Variants } from 'framer-motion'
import { title } from 'process'
import TitrePartie from '../Components/TitrePartie'
import ellipse6 from "../Files/ellipse6.svg";
import { useNavigate } from 'react-router-dom'
import { FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TelegramIcon, TelegramShareButton, TwitterIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share'
import { generateText } from '../Services/api/GenerationTexte'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import 'react-chat-elements/dist/main.css';
import { ChatList, MessageList } from 'react-chat-elements'
import datas from "../Data/.json"
import logo from '../Files/IBG Logo.svg'

import TypingText from '../Components/TypingText'
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import LanguageDetect from "languagedetect"
import { alignProperty } from '@mui/material/styles/cssUtils'
import avatarMoi from "../Files/avatarMoi.svg"
import avatarIa from "../Files/avatarIa.svg"
import env from 'react-dotenv'
import { Riple } from 'react-loading-indicators'

const API_KEY: any = process.env.REACT_APP_GEMINI_API_KEY;

interface Props { }

function FocusIA(props: Props) {
    const { } = props
    const { t, i18n } = useTranslation();
    const navigate = useNavigate()

    const [prompt, setPrompt] = useState("");
    const [result, setResult] = useState("");
    const [loading, setLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(true);

    const [lecture, setLecture] = useState(false)
    const [alertError, setAlertError] = useState(false)
    const [alertErrorSpeech, setAlertErrorSpeech] = useState(false)


    const [messages, setMessages] = useState<any>([]);
    const [userMessage, setUserMessage] = useState("");

    // if (pageLoaded) {
    //     setPageLoaded(false)
    //     try {
    //         var data = JSON.parse(localStorage.getItem(datas.chat) + "") as []
    //         // var tmp = [];

    //         // for (let index = 0; index < data.length; index++) {
    //         //     const element = data[index] as any;
    //         //     tmp.push({
    //         //         key:index,
    //         //         ref: React.createRef(),
    //         //         ...element
    //         //     })
    //         // }
    //         // alert(JSON.stringify(tmp))

    //         // if (data) {
    //         //     setMessages(data)
    //         // }
    //     } catch (error) {
    //         alert(error)
    //     }
    // }
    const handleSendMessage = async () => {
        if (userMessage.trim() === "") return;

        const newMessage = {
            // sender: "Moi",
            position: 'right',
            type: 'text',
            text: <Box bgcolor={"rgb(255, 255, 255, .1)"} boxShadow={"1px 0px 10px rgba(0, 0, 0, .1)"} padding={2} borderRadius={10}>{userMessage}</Box>,
            date: new Date(),
            avatar: avatarMoi,
        };
        // alert(JSON.stringify([...messages, newMessage]))
        localStorage.setItem(datas.chat, JSON.stringify([...messages, newMessage]))
        setMessages([...messages, newMessage]);
        setUserMessage("");
        setLoading(true);

        try {
            const response = await generateText(userMessage, API_KEY);
            const botMessage = {
                position: 'left',
                type: 'text',
                text: <TypingText text={response} />,
                date: new Date(),
                avatar: avatarIa,
            };
            setMessages((prevMessages: any) => [...prevMessages, botMessage]);
        } catch (error) {
            const errorMessage = {
                position: 'center',
                type: 'text',
                text: <label style={{ color: "red", fontWeight: "bold" }} htmlFor="">Erreur lors de la génération !!! </label>,
                date: new Date(),
            };
            setMessages((prevMessages: any) => [...prevMessages, errorMessage]);
        } finally {
            setLoading(false);
        }
    };

    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition
    } = useSpeechRecognition();

    // if (!browserSupportsSpeechRecognition) {
    //     return <span>Browser doesn't support speech recognition.</span>;
    // }

    setTimeout(() => {
        if (listening) {
            setUserMessage(transcript)
        }
    }, listening ? 1 : 0)

    function handleSpeechMessage() {
        try {
            setLecture(true)
            const msg = new SpeechSynthesisUtterance()
            msg.text = messages[messages.length - 1].text.props.text.replaceAll("*", "")

            // Détection automatatique de lanque
            const lngDetector = new LanguageDetect();
            msg.lang = (lngDetector.detect(msg.text)[0][0] == "french" ? "fr-fr" : "en-en")

            msg.onend = () => setLecture(false)
            window.speechSynthesis.speak(msg)
        } catch (error) {
            setAlertErrorSpeech(true)
            setTimeout(() => {
                setAlertErrorSpeech(false)
            }, 3000);
        }

        // OR
        // const lngDetector = new (require('languagedetect'));

    }

    return (
        <div style={{ backgroundColor: "inherit" }} >
            <TopHeader />
            <Header /><br />
            <TitrePage hiddeTitle image={image} titre={"titrePage.FocusIA.titre"} lien='focusia' pageDescription={'titrePage.FocusIA.description'} keyWords={'titrePage.FocusIA.keywords'} />
            <br /><br />
            <Container maxWidth="md">
                <div>
                    <Box bgcolor={"#cfd0ff"} color={"#333"} border={"1px #cfd0ff solid"} padding={1} alignItems={"space-between"} display={"flex"}>
                        <label style={{ fontWeight: "bold", marginTop: "5px" }} htmlFor="">{t("titrePage.FocusIA.titre")}</label>
                        <hr style={{ visibility: "hidden" }} />
                        <img width={30} src={logo} alt="" />
                    </Box>

                    <div style={{ height: "500px", width: "100%", overflow: "auto", display: "flex", flexDirection: "column-reverse" }}>

                        {messages.length > 0 ? "" : <Box height={"100%"} alignContent={"center"}> <h1>{t("startChat")}</h1></Box>}
                        <MessageList
                            className="message-list"
                            lockable={true}
                            toBottomHeight={'100%'}
                            dataSource={messages}
                            messageBoxStyles={{ textAlign: "left", background: 'none', borderRadius: "10px", boxShadow: "none", overflow: "visible", maxWidth: "90%" }}
                            notchStyle={{ visibility: "hidden" }}
                            sendMessagePreview
                            referance={React.createRef()}
                        />
                    </div>
                    {loading ? <Riple color="rgb(25, 7, 143)" size="small" text="" textColor="" /> : ""}
                    {alertError ? <Alert variant="filled" severity="error">
                        {t("errorSpeech")}
                    </Alert>
                        :
                        ""}
                    {alertErrorSpeech ? <Alert variant="filled" severity="error">
                        {t("errorSpeech2")}
                    </Alert>
                        :
                        ""}
                    <Form style={{ display: 'flex', marginTop: '10px' }} onFinish={handleSendMessage}>
                        {/* <input placeholder={t("placeholderMail")} className='inp' type="text" />
                        <button className='btn'>{t("souscrire")}</button> */}
                        <Box boxShadow={"0px 0px 10px rgba(0, 0, 0, .1)"} bgcolor={"white"} padding={"10px"} borderRadius={"20px"} display={"flex"} width={"100%"}>
                            <IconButton onClick={() => {
                                if (!browserSupportsSpeechRecognition) {
                                    setAlertError(true)

                                    setTimeout(() => {
                                        setAlertError(false)
                                    }, 3000);
                                }
                                SpeechRecognition.startListening()
                            }}><Mic color={(listening || !browserSupportsSpeechRecognition) ? 'disabled' : "info"} /></IconButton>
                            <textarea
                                rows={3}
                                className='inp2'
                                value={userMessage}
                                onKeyDown={(e) => {
                                    if (e.which === 13) {
                                        handleSendMessage()
                                    }
                                }}
                                onChange={(e) => {
                                    if (e.target.value != '\n') {
                                        setUserMessage(e.target.value)
                                    }
                                }}
                                placeholder={t("placeholderChat")}
                                onSubmit={handleSendMessage}
                                style={{ flex: 1, marginRight: '10px', border: "none", resize: "none" }}
                            />
                            {lecture ? <IconButton onClick={() => { window.speechSynthesis.cancel(); setLecture(false) }}><VoiceOverOff color='error' /></IconButton> : ""}
                            {!lecture ? <IconButton disabled={messages.length == 0} onClick={handleSpeechMessage}><RecordVoiceOver color={messages.length == 0 ? "disabled" : "secondary"} /></IconButton> : ""}
                            <IconButton onClick={handleSendMessage}><SendRounded color='info' /></IconButton>

                        </Box>


                        {/* <button className='btn' onClick={handleSendMessage} disabled={loading}>
                            {loading ? "Envoi en cours..." : "Envoyer"}
                        </button> */}
                    </Form>
                    <label htmlFor="" style={{ opacity: "50%", fontSize: "60%" }}><i>{t("footerChat")}</i></label>
                </div>
            </Container>
            <br /><br />
            <Footer />
        </div>
    )
}

export default FocusIA